import { useDispatch } from 'react-redux';
import { GET_PRESIGNED_UPLOAD_URL } from '../constants/urlConstants';
import apiRequest from '../util/apiRequest';
import { CSV_MIME_TYPE } from '../constants/campaignConstants';
import { SHOW_NOTIFICATON } from '../actions/notificationActionsType';
import { DEFAULT_NOTIFICATION_TIMEOUT_MS, MessageType } from '../constants/createSegment';
import { PARENTEX_FAILURE, PARENTEX_SUCESS } from '../constants/messages';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { CAMPAIGN_LIST_PAGE } from '../constants/routesConstant';

export const useParentExNudge = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);

  const uploadParentExFile = file => {
    setIsLoading(true);
    const url = GET_PRESIGNED_UPLOAD_URL;
    const payload = {};
    apiRequest(url, {
      method: 'POST',
      body: JSON.stringify(payload),
    })
      .then(res => {
        return res.json();
      })
      .then(res => {
        const headers = {
          'Content-Type': CSV_MIME_TYPE,
          'Access-Control-Allow-Origin': '*',
        };

        return fetch(res?.presignedUrl, {
          method: 'PUT',
          headers,
          body: file,
        });
      })
      .then(res => {
        if (res?.status === 200) {
          dispatch({
            type: SHOW_NOTIFICATON,
            payload: {
              type: MessageType.SUCCESS,
              timeout: 10000,
              message: PARENTEX_SUCESS,
            },
          });
          history.push(CAMPAIGN_LIST_PAGE);
        }
      })
      .catch(err => {
        dispatch({
          type: SHOW_NOTIFICATON,
          payload: {
            type: MessageType.ERROR,
            timeout: DEFAULT_NOTIFICATION_TIMEOUT_MS,
            message: PARENTEX_FAILURE,
          },
        });
      }).finally(() => {
        setIsLoading(false);
      })
  };

  return {
    uploadParentExFile,
    isLoading
  };
}

export default useParentExNudge;
